// Shrink big phone photos before upload: cap the longest edge and re-encode as
// JPEG. A 3-5MB camera photo becomes a few hundred KB → much faster upload + OCR,
// while a lottery bet grid stays perfectly legible. Falls back to the raw file
// (or null) if the browser can't decode/encode it, so a scan never hard-fails here.
export const downscaleImage = (file, maxEdge = 1280) => new Promise((resolve) => {
    try {
        const reader = new FileReader();
        reader.onload = (ev) => {
            const src = ev.target.result;
            const img = new Image();
            img.onload = () => {
                try {
                    const scale = Math.min(1, maxEdge / Math.max(img.width, img.height));
                    const w = Math.max(1, Math.round(img.width * scale));
                    const h = Math.max(1, Math.round(img.height * scale));
                    const canvas = document.createElement('canvas');
                    canvas.width = w; canvas.height = h;
                    canvas.getContext('2d').drawImage(img, 0, 0, w, h);
                    const outUrl = canvas.toDataURL('image/jpeg', 0.82);
                    resolve({ dataUrl: outUrl, base64: outUrl.split(',')[1], mime: 'image/jpeg' });
                } catch {
                    resolve({ dataUrl: src, base64: src.includes(',') ? src.split(',')[1] : src, mime: file.type });
                }
            };
            img.onerror = () => resolve({ dataUrl: src, base64: src.includes(',') ? src.split(',')[1] : src, mime: file.type });
            img.src = src;
        };
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(file);
    } catch {
        resolve(null);
    }
});
